import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const OrderTracking = () => {
  return (
    <div>
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '1000px', margin: '40px auto', padding: '20px' }}>
          <h1 style={{ marginBottom: '30px', color: '#FF0000', fontSize: '32px', fontWeight: '700' }}>
            📦 Suivi de Commande
          </h1>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Comment suivre votre commande ?
            </h2>
            <div style={{ lineHeight: '1.8', color: '#666' }}>
              <p style={{ marginBottom: '15px' }}>
                Le suivi de votre commande est simple et transparent. Voici comment procéder :
              </p>
              <ol style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Connectez-vous à votre compte</strong> et accédez à la section "Mes Commandes"
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Sélectionnez la commande</strong> que vous souhaitez suivre
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Cliquez sur "Voir le suivi détaillé"</strong> pour accéder à toutes les informations
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Consultez le Tracking ID</strong> unique qui vous a été attribué
                </li>
              </ol>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Statuts de commande
            </h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>📝</span>
                  <h3 style={{ margin: 0, color: '#856404' }}>Commandée</h3>
                </div>
                <p style={{ margin: 0, color: '#856404' }}>
                  Votre commande a été enregistrée et est en attente de validation par un agent.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>💳</span>
                  <h3 style={{ margin: 0, color: '#0c5460' }}>Payée</h3>
                </div>
                <p style={{ margin: 0, color: '#0c5460' }}>
                  Le paiement a été confirmé. Votre commande est en cours de traitement.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>🚚</span>
                  <h3 style={{ margin: 0, color: '#856404' }}>Expédiée</h3>
                </div>
                <p style={{ margin: 0, color: '#856404' }}>
                  Votre commande a été expédiée et est en route vers la RDC.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#d4edda', borderRadius: '8px', border: '1px solid #28a745' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>✅</span>
                  <h3 style={{ margin: 0, color: '#155724' }}>Livrée</h3>
                </div>
                <p style={{ margin: 0, color: '#155724' }}>
                  Votre commande a été livrée avec succès. Profitez de votre achat !
                </p>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Statuts de livraison
            </h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>📦</span>
                  <h3 style={{ margin: 0, color: '#495057' }}>Non expédié</h3>
                </div>
                <p style={{ margin: 0, color: '#495057' }}>
                  Votre commande n'a pas encore été expédiée.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>🚚</span>
                  <h3 style={{ margin: 0, color: '#0c5460' }}>En transit</h3>
                </div>
                <p style={{ margin: 0, color: '#0c5460' }}>
                  Votre commande est en cours de transport vers la RDC.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>📦</span>
                  <h3 style={{ margin: 0, color: '#856404' }}>Arrivé en RDC</h3>
                </div>
                <p style={{ margin: 0, color: '#856404' }}>
                  Votre commande est arrivée en RDC et est en cours de traitement pour la livraison locale.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>🏠</span>
                  <h3 style={{ margin: 0, color: '#0c5460' }}>Prêt à être livré</h3>
                </div>
                <p style={{ margin: 0, color: '#0c5460' }}>
                  Votre commande est prête et sera livrée sous peu à l'adresse indiquée.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#d4edda', borderRadius: '8px', border: '1px solid #28a745' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '24px' }}>✅</span>
                  <h3 style={{ margin: 0, color: '#155724' }}>Livré</h3>
                </div>
                <p style={{ margin: 0, color: '#155724' }}>
                  Votre commande a été livrée avec succès à l'adresse indiquée.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Questions fréquentes
            </h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Combien de temps faut-il pour recevoir ma commande ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Le délai de livraison varie entre 15 et 30 jours ouvrables selon la destination et le type de produit.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Puis-je modifier l'adresse de livraison après avoir passé commande ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Vous pouvez modifier l'adresse de livraison tant que la commande n'a pas été expédiée. Contactez notre support pour toute modification.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Que faire si je ne reçois pas ma commande ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Si votre commande n'arrive pas dans les délais prévus, contactez immédiatement notre service client. Nous enquêterons et vous tiendrons informé.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrderTracking;





